module.exports = __webpack_public_path__ + "static/media/slideshow-35.59b0faed.jpeg";